export const VERSION_APP = '1.2.8';
export const HOME_DIR = '/';
export const ENV = {
    PROD: {
        API_BASE_URL1: 'https://script.google.com/macros/s/AKfycbx8zjJwF-MtUwHBkwVQ_HKhTZP4nuWjH0qulD6DIIbwmvkBZ2_SH2d8qvupkch5K60r/exec',
        API_BASE_URL2: 'https://script.google.com/macros/s/AKfycbxD3DMsfKbLIcNv_gkkMDP2Cou1fiWZ6DCMo_ubWk4BgEv8dMkEbFP1JO60Vz5vRAvZ/exec',
        API_BASE_URL3: 'https://script.google.com/macros/s/AKfycbxzPAR7wD1BjafrIgzQuUkCM0Z8s9EyNTbLTAiECP4YjktE8LHktcPXxNcmBa85Vpaz/exec',
        API_BASE_URL4: 'https://script.google.com/macros/s/AKfycbzdgT8PXyz8WgmRdBpAq-8REm0Y6Qs1HARFj-JfWPa-yHOGG_IjM4t9muCR-_TEJ2PLeg/exec',
        API_BASE_URL5: 'https://script.google.com/macros/s/AKfycbz6iFwuxZOKMSk6H3RNOuntmP3KN8w5Ag0Di7-hwALbw_ZX8oHYk3KORQxcoHLa20a4/exec',
        API_BASE_URL6: 'https://script.google.com/macros/s/AKfycbyhNHbyZWV909ecO8bQB6n_Md8TzfLAPjzntyRxTQ4M3wg0n-H2z7hauGtG6Hk1ypgZpg/exec',
        API_BASE_URL7: 'https://script.google.com/macros/s/AKfycbwkHuhMIohZZnw8wY63SucrzXqii0OhnJqbUGOFFWK2wXIDSNhDRxKEXkWjWgaX4_m1/exec',
        API_BASE_URL8: 'https://script.google.com/macros/s/AKfycbxhXKwfxh5om1N9cEqYFev2aaTcPD0jDngOOne_PaaxQ1h-5I0Bqn_qf3XAZKsTvLQy/exec',
        API_BASE_URL9: 'https://script.google.com/macros/s/AKfycbzMoGNVVQNORv7jxGLGJ6X5KLShYxnBlNe44iNYMWn1LbOEvMV8XbLkOqsOpCMSPuID/exec',
        API_BASE_URL10: 'https://script.google.com/macros/s/AKfycbz1xGojK6xqpdWQAMaiX8cHbHU8JwD4kNxPcHyV8r-lBe2RSnEj3IAk8M9mykrNhFEwhg/exec',
        API_BASE_URL11: 'https://script.google.com/macros/s/AKfycbzSPYS7xMrd6uRgwQv-3M746Cy1oi7s5hmH93pBannu7U3W7hCOl2nbkIfg-aFSLJ5Wvw/exec',
        API_BASE_URL12: 'https://script.google.com/macros/s/AKfycbyawrFa-XJXvQnXBdd9T_Q3trJQVsjpPx8eAfOufG0FLvUp4r27I_bFXM_42JstKr4m/exec',
        API_BASE_URL13: 'https://script.google.com/macros/s/AKfycbzc4NIdrioqc9eOqGnpy-iIHLqPxFvs7V72_9DwGMRmWZ8AvOkCgK7IObxCtcMRY7RBgw/exec',
        API_BASE_URL14: 'https://script.google.com/macros/s/AKfycbyCTW_ucKubw9Yd0-8gOZOGLltPWAiepUKheNCr0OoHqggjYsntbeKH7wlOeJpg1s46/exec',
        API_BASE_URL15: 'https://script.google.com/macros/s/AKfycbwy3WuJhXRfm_P_3cH3AjI-qsooHpsc6KFNtO9Enacge7veXBnz_FJwd5LNUR1KBZrA/exec',
        API_BASE_URL16: 'https://script.google.com/macros/s/AKfycbykGa_X7brglV7P8OoVUTNGuQwA2eSViwiZuuowCz3J63xcwwt8H88j3AQADmCPLbnq/exec',
        API_BASE_URL17: 'https://script.google.com/macros/s/AKfycbz22gk8M0UocRwcMSHuXrzMrUhp-s3a2NLeJElhFo3bEcqcXOh2sJYGzV29TvcOKkNbSQ/exec',
        API_BASE_URL18: 'https://script.google.com/macros/s/AKfycbwpCUwP2nwoEI7R2SaRbtywahzb2Jg5WITB6fKDVWfODRbucbWGg43jmyqENFJ_dU_1/exec',
        API_BASE_URL19: 'https://script.google.com/macros/s/AKfycbxtsj5M3u5LUFM6fpeqZxIfdu_HZWIjS1plbzc5joUbvucGyZVXzbEAzAMGExnYuWeM/exec',
        API_BASE_URL20: 'https://script.google.com/macros/s/AKfycbx_qPMmvU56kWG8mbFJXlvCopScFehAca81_L_RvykhZBD4vLYRDOCoinY9gZioh4nZIQ/exec',
        API_BASE_URL21: 'https://script.google.com/macros/s/AKfycbwg8I45nxvlLO-a3_mOy4u6sR2Ju0GOiXRZEsVMZoglsyAMY3T48BWcC8YlSCIlf4Su/exec',
        API_BASE_URL22: 'https://script.google.com/macros/s/AKfycbxWSBDx6-CJCIjvieVSvzfw6XaWuwqHuLz6s2T_OV23xgA63PgzBoH9ImaRthkR4IKQ/exec',
        API_BASE_URL23: 'https://script.google.com/macros/s/AKfycbx1rFKBb-T8dTtJDgvOk_Ui4S5heISb6NpK5FFiwj1m8xammtJ21iX8gC0-1XudBDSgkg/exec',
        API_BASE_URL24: 'https://script.google.com/macros/s/AKfycbxR50GjSgRnbDoWGxkrDBTTIIgMyPoXv74IRmOLgn3CKg4TV1HoAZ3dESRiEqRZoWtS/exec',
        API_BASE_URL25: 'https://script.google.com/macros/s/AKfycbxTnjgM-EnXjmB1_kyOPqEfJ7U_eCOJpV1SRbwPLLPVZIpJ8leOt9zBHpOEE9HWNlqn4A/exec',
        LIFF_ID1: '2005555066-VkP7oKgp',
        LIFF_ID2: '2005555066-6jq5W2EM',
        LIFF_ID3: '2005555066-L2DRKd4X',
        LIFF_ID4: '2005555066-XwyJ6EVl',
        LIFF_ID5: '2005555066-QggZnp9y',
        LIFF_ID6: '2005555066-M8GNo32r',
        LIFF_ID7: '2005555066-BWVYxlQo',
        LIFF_ID8: '2005555066-p5Em1yeV',
        LIFF_ID9: '2005555066-bxPBMzZ0',
        LIFF_ID10: '2005555066-jAKGqxzQ',
        LIFF_ID11: '2005555066-dmwGkNM2',
        LIFF_ID12: '2005555066-0yrRejZJ',
        LIFF_ID13: '2005555066-QpEgWPqK',
        LIFF_ID14: '2005555066-jxWr1onY',
        LIFF_ID15: '2008398161-Vmd1a1jw',
        LIFF_ID16: '2008435180-RZqQvPpA',
        LIFF_ID17: '2008435180-zRQd2o7f',
        LIFF_ID18: '2008435180-cVZwlKAM',
        LIFF_ID19: '2008435180-C1CtfgUR',
        LIFF_ID20: '2008435180-Iz0obvJ9',
        LIFF_ID21: '2008435180-frgurvjI',
        LIFF_ID22: '2008435180-kwIBUuot',
        LIFF_ID23: '2008435180-ACxWx865',
        LIFF_ID24: '2008435180-DWBaKXAh',
        LIFF_ID25: '2008435180-d0iZAEfF',
        FLEX_IMAGE1: 'https://i.postimg.cc/tJ5Zq4kh/flex1.jpg',
        FLEX_IMAGE2: 'https://i.postimg.cc/yxPg18jr/flex2.jpg',
        FLEX_IMAGE3: 'https://i.postimg.cc/QCb98dmP/flex3.jpg',
        FLEX_IMAGE4: 'https://i.postimg.cc/GtQ8LmK5/flex4.jpg',
        FLEX_IMAGE5: 'https://i.postimg.cc/4y57fxP0/flex5.jpg',
        FLEX_IMAGE6: 'https://i.postimg.cc/nrkjFh2y/flex6.jpg',
        FLEX_IMAGE7: 'https://i.postimg.cc/66LGLMKp/flex7.jpg',
        FLEX_IMAGE8: 'https://i.postimg.cc/Y2fmfd72/flex8.jpg',
        FLEX_IMAGE9: 'https://i.postimg.cc/FFgJgTvz/flex9.jpg',
        FLEX_IMAGE10: 'https://i.postimg.cc/G3JsJXR8/flex10.jpg',
        FLEX_IMAGE11: 'https://i.postimg.cc/XNcycsWr/flex11.jpg',
        FLEX_IMAGE12: 'https://i.postimg.cc/zDSRSxNH/flex12.jpg',
        FLEX_IMAGE13: 'https://i.postimg.cc/Wp6J65Vg/flex13.jpg',
        FLEX_IMAGE14: 'https://i.postimg.cc/gcq6qgpq/flex14.jpg',
        FLEX_IMAGE15: 'https://i.postimg.cc/ryCtCfTN/flex15.jpg',
        FLEX_IMAGE16: 'https://i.postimg.cc/y6XSXLKP/flex16.jpg',
        FLEX_IMAGE17: 'https://i.postimg.cc/xjyby6Qg/flex17.jpg',
        FLEX_IMAGE18: 'https://i.postimg.cc/28kLHnjd/flex18.jpg',
        FLEX_IMAGE19: 'https://i.postimg.cc/7YHJBSP3/flex19.jpg',
        FLEX_IMAGE20: 'https://i.postimg.cc/FsrkP0Fg/flex20.jpg',
        FLEX_IMAGE21: 'https://i.postimg.cc/CLhnvbMr/flex21.jpg',
        FLEX_IMAGE22: 'https://i.postimg.cc/Dyv4C1yT/flex22.jpg',
        FLEX_IMAGE23: 'https://i.postimg.cc/BQSPh2QG/flex23.jpg',
        FLEX_IMAGE24: 'https://i.postimg.cc/CLhnvbLY/flex24.jpg',
        FLEX_IMAGE25: 'https://i.postimg.cc/Qx8K6cxD/flex25.jpg',
    }
}

export const CURRENT_ENV = ENV.PROD;
